import { Model } from '@client:common/Model';
import { Theme } from '@client:common/Theme';

import './ModelCard.light.scss';
import './ModelCard.dark.scss';

interface Props {
  model: Model;
  currentTheme?: Theme;
}

export function ModelCard(props: Props) {
  return (
    <>
      <figure className='model-card__image'>
        <div className='model-card__image-container'>
          {props.model.imageUrl && props.model.imageUrl_dark ? (
            props.currentTheme === 'dark' ? (
              <img
                className='model-image'
                src={props.model.imageUrl_dark} />
            ) : (
              <img
                className='model-image'
                src={props.model.imageUrl} />
            )
          ) : props.model.imageUrl ? (
            <img
              className='model-image'
              src={props.model.imageUrl} />
          ) : (
            <p className='acronym-logo'>{props.model.acronym}</p>
          )}
        </div>
      </figure>
      <div className='model-card__body'>
        <div className='model-card__action-container'>
          <div className='model-card__acronym' dangerouslySetInnerHTML={{ __html: props.model.acronym ? props.model.acronym : '' }}></div>
          <div className='model-card__name' dangerouslySetInnerHTML={{ __html: props.model.name ? props.model.name : props.model.acronym ?? '' }}></div>
          <div className='model-card__org'>
            {props.model.institution.map((item: any, index: number) => (
              <span key={index} dangerouslySetInnerHTML={{ __html: item }}></span>
            ))}
          </div>
          <div className='model-card__description' dangerouslySetInnerHTML={{ __html: props.model.primaryUse }}></div>
        </div>
      </div>
    </>
  );
}
